import {
  Checkbox as AntdCheckbox,
  Checkbox,
  Col,
  DatePicker,
  Input as AntdInput,
  Modal as AntdModal,
  Row,
  Select,
  Tabs
} from "antd";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import "react-tabs/style/react-tabs.css";
import { Button, Icon, Input, Modal, TextArea } from "semantic-ui-react";
import { changeNewPatient } from "../../action/addAction";
import { getGroups } from "../../action/patientAction";
import {
  getPrescribingStaff,
  getPrescribingStaffChanged
} from "../../action/registerAction";
import { phoneWithCountryFormat } from "../../tools/phoneFormat";
import { uppercaseFirstStr } from "../../tools/stringProcess";
import ButtonSuccess from "../home/buttonSuccess";
import "./editpatient.css";
import EnrollmentCriteria from "./EnrollmentCriteria";
import { PATIENT_RESIDENCE } from "../../tools/patient-medical";

const { TabPane } = Tabs;
const GenderList = [
  { gender: "", key: "1" },
  { gender: "Female", key: "2" },
  { gender: "Male", key: "3" },
  { gender: "Other", key: "4" },
  { gender: "Prefer not to say", key: "5" }
];
const SecRela = [
  { rela: "", key: "1" },
  { rela: "Spouse/Partner", key: "2" },
  { rela: "Sibling", key: "3" },
  { rela: "Child", key: "4" },
  { rela: "Niece/Nephew", key: "5" },
  { rela: "Grandchild", key: "6" },
  { rela: "Caregiver", key: "7" },
  { rela: "Other", key: "8" }
];

class EditNewPatientsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      birthday: null,
      open: false,
      siteId: "",
      firstName: "",
      lastName: "",
      email: "",
      patientMBI: "",
      patientResidence: "",
      contactName: "",
      secondaryEmail: "",
      contactPhone: "",
      relation: "",
      confirmSuccess: false,
      patientNote: "",
      otherCondition: null,
      neuropathyCondition: false,
      amputationCondition: false,
      ulcersCondition: false,
      charcotCondition: false,
      PADCondition: false,
      otherCheckCondition: false,
      medicalCondition: "",
      medicalConditions: [],
      birYear: "",
      birMonth: "",
      birDay: "",
      phone: "",
      homePhone: "",
      patientId: "",
      doctorId: "",
      authSecondary: false,
      dispenseType: "",
      dispenseAddress: "",
      dispenseCity: "",
      dispenseState: "",
      dispenseZip: "",
      dispenseSize: "",
      dispenseColor: "",
      dispenseComment: "",
      selRightToe: false,
      selRightMts: false,
      selRightArch: false,
      selRightHeel: false,
      selLeftToe: false,
      selLeftMts: false,
      selLeftArch: false,
      selLeftHeel: false,
      gender: "",
      enableApp: false,
      enableEmail: false,
      enableSms: false,
      enableWarning: false
    };
    this.handleSiteIdChange = this.handleSiteIdChange.bind(this);
    this.changeMBI = this.changeMBI.bind(this);
    this.onChangedDoctor = this.onChangedDoctor.bind(this);
    this.handleRelChange = this.handleRelChange.bind(this);
    this.changePatientNote = this.changePatientNote.bind(this);
    this.onChangePatientCondition = this.onChangePatientCondition.bind(this);
    this.changeGender = this.changeGender.bind(this);
  }

  componentDidMount() {
    this.setState({ gender: this.props.userInfo.gender });
  }

  onChangeOtherCondition = event => {
    this.setState({
      otherCondition: event.target.value
    });
  };

  onChangePatientCondition = checkedValues => {
    let otherCondition = this.state.otherCondition;
    if (checkedValues.indexOf("Other") < 0) {
      otherCondition = "";
      this.setState({ otherCondition });
    }
    let medicalCondition = checkedValues
      .map(t => {
        return t;
      })
      .join(",");
    this.setState({
      medicalConditions: checkedValues,
      medicalCondition
    });
  };

  onChangeDispenseComment = event => {
    this.setState({ dispenseComment: event.target.value });
  };
  changeGender = event => {
    this.setState({ gender: event });
  };
  onChangeDispenseStyle = e => {
    this.setState({ dispenseType: e.target.value });
  };

  onChangeSockSize = e => {
    this.setState({ dispenseSize: e.target.value });
  };

  onChangeSockColor = e => {
    this.setState({ dispenseColor: e.target.value });
  };

  onChangeAddress = e => {
    this.setState({ dispenseAddress: e.target.value });
  };
  onChangeCity = e => {
    this.setState({ dispenseCity: e.target.value });
  };
  onChangeState = e => {
    this.setState({ dispenseState: e.target.value });
  };
  onChangeZip = e => {
    this.setState({ dispenseZip: e.target.value });
  };

  componentDidMount() {
    // const { getGroups } = this.props;
    // getGroups();
  }
  onChangedDoctor(event) {
    this.setState({ doctorId: event });
  }
  handleSiteIdChange(event) {
    const { getPrescribingStaffChanged } = this.props;
    this.setState({ siteId: event });
    getPrescribingStaffChanged(event, this);
  }
  handleFirstNameChange(value) {
    this.setState({ firstName: uppercaseFirstStr(value) });
  }
  handleLastNameChange(value) {
    this.setState({ lastName: uppercaseFirstStr(value) });
  }
  handleEmailChange(value) {
    this.setState({ email: value });
  }
  changeMBI(value) {
    this.setState({ patientMBI: value });
  }
  changePatientResidence = event => {
    this.setState({ patientResidence: event });
  };
  handleContactNameChange(value) {
    this.setState({ contactName: uppercaseFirstStr(value) });
  }
  handleSecondaryEmailChange(value) {
    this.setState({ secondaryEmail: value });
  }
  handleRelChange(event) {
    this.setState({ relation: event });
  }
  handlePhoneChange = contactPhone => {
    let noSym1 = contactPhone.replace("(", "");
    let noSym2 = noSym1.replace(")", "");
    let noSym3 = noSym2.replace("-", "");
    let noBlank = noSym3.replace(/\s+/g, "");
    this.setState({ contactPhone: noBlank });
  };

  handleOpen = () => {
    const { getPrescribingStaff } = this.props;
    getPrescribingStaff(this.props.userInfo.siteId);
    this.setState({
      enableApp: this.props.userInfo.enableApp || false,
      enableEmail: this.props.userInfo.enableEmail || false,
      enableSms: this.props.userInfo.enableSms || false,
      birthday: this.props.userInfo.birthday || null,
      open: true,
      confirmSuccess: false,
      siteId:
        this.props.userInfo && this.props.userInfo.siteId
          ? this.props.userInfo.siteId
          : "",
      lastName:
        this.props.userInfo && this.props.userInfo.lastName
          ? uppercaseFirstStr(this.props.userInfo.lastName.trim())
          : "",
      firstName:
        this.props.userInfo && this.props.userInfo.firstName
          ? uppercaseFirstStr(this.props.userInfo.firstName.trim())
          : "",
      email:
        this.props.userInfo && this.props.userInfo.email
          ? this.props.userInfo.email.toLowerCase()
          : "",
      patientMBI:
        this.props.userInfo && this.props.userInfo.patientMBI
          ? this.props.userInfo.patientMBI
          : "",
      patientResidence:
        this.props.userInfo && this.props.userInfo.patientResidence
          ? this.props.userInfo.patientResidence
          : "",
      contactName:
        this.props.userInfo && this.props.userInfo.contactName
          ? uppercaseFirstStr(this.props.userInfo.contactName)
          : "",
      secondaryEmail:
        this.props.userInfo && this.props.userInfo.secondaryEmail
          ? this.props.userInfo.secondaryEmail.toLowerCase()
          : "",
      contactPhone:
        this.props.userInfo && this.props.userInfo.contactPhone
          ? phoneWithCountryFormat(this.props.userInfo.contactPhone)
          : "",
      relation:
        this.props.userInfo && this.props.userInfo.relation
          ? this.props.userInfo.relation
          : "",
      patientNote:
        this.props.userInfo && this.props.userInfo.patientNotes
          ? this.props.userInfo.patientNotes
          : "",
      medicalCondition:
        this.props.userInfo && this.props.userInfo.medicalCondition
          ? this.props.userInfo.medicalCondition
          : "",
      birYear:
        this.props.userInfo && this.props.userInfo.birthday.split("-")[0],
      birMonth:
        this.props.userInfo && this.props.userInfo.birthday.split("-")[1],
      gender: this.props.userInfo && this.props.userInfo.gender,
      birDay: this.props.userInfo && this.props.userInfo.birthday.split("-")[2],
      doctorId:
        this.props.userInfo && this.props.userInfo.doctorId
          ? this.props.userInfo.doctorId
          : "",
      patientId:
        this.props.userInfo && this.props.userInfo.patientId
          ? this.props.userInfo.patientId
          : "",
      phone:
        this.props.userInfo && this.props.userInfo.phone
          ? phoneWithCountryFormat(this.props.userInfo.phone)
          : "",
      homePhone:
        this.props.userInfo && this.props.userInfo.homePhone
          ? phoneWithCountryFormat(this.props.userInfo.homePhone)
          : "",
      authSecondary: !!(
        this.props.userInfo &&
        this.props.userInfo.authSecondaryContact &&
        this.props.userInfo.authSecondaryContact === "Yes"
      ),
      dispenseType:
        this.props.userInfo && this.props.userInfo.dispenseType
          ? this.props.userInfo.dispenseType
          : "",
      dispenseAddress:
        this.props.userInfo && this.props.userInfo.dispenseAddress
          ? this.props.userInfo.dispenseAddress
          : "",
      dispenseCity:
        this.props.userInfo && this.props.userInfo.dispenseCity
          ? this.props.userInfo.dispenseCity
          : "",
      dispenseState:
        this.props.userInfo && this.props.userInfo.dispenseState
          ? this.props.userInfo.dispenseState
          : "",
      dispenseZip:
        this.props.userInfo && this.props.userInfo.dispenseZip
          ? this.props.userInfo.dispenseZip
          : "",
      dispenseSize:
        this.props.userInfo && this.props.userInfo.dispenseSize
          ? this.props.userInfo.dispenseSize
          : "",
      dispenseColor:
        this.props.userInfo && this.props.userInfo.dispenseColor
          ? this.props.userInfo.dispenseColor
          : "",
      dispenseComment:
        this.props.userInfo && this.props.userInfo.dispenseComments
          ? this.props.userInfo.dispenseComments
          : ""
    });
    let symptomDetail =
      this.props.userInfo && this.props.userInfo.symptomDetail
        ? this.props.userInfo.symptomDetail
        : "";
    if (!_.isEmpty(symptomDetail)) {
      let symptoms = symptomDetail.split(",");
      if (symptoms.length === 2) {
        let symptom1 = symptoms[0];
        let symptom2 = symptoms[1];
        this.extracted(symptom1);
        this.extracted(symptom2);
      } else if (symptoms.length === 1) {
        let symptom1 = symptoms[0];
        this.extracted(symptom1);
      }
    }
    let medicalCondition =
      this.props.userInfo && this.props.userInfo.medicalCondition
        ? this.props.userInfo.medicalCondition
        : "";
    if (!_.isEmpty(medicalCondition)) {
      let medicalConditions = medicalCondition.split(",");
      if (medicalCondition.includes("Other-")) {
        this.setState({
          otherCondition: medicalConditions[medicalConditions.length - 1].split(
            "-"
          )[1]
        });
        medicalConditions.pop();
      }
      this.setState({ medicalConditions });
    }
  };

  onChangeContactPhone = event => {
    this.setState({ enableApp: event.target.checked });
  };

  onChangeContactEmail = event => {
    this.setState({ enableEmail: event.target.checked });
  };

  onChangeContactMessage = event => {
    this.setState({ enableSms: event.target.checked });
  };

  extracted(symptom1) {
    if (symptom1.includes("left:")) {
      if (symptom1.includes("toe")) {
        this.setState({ selLeftToe: true });
      }
      if (symptom1.includes("mts")) {
        this.setState({ selLeftMts: true });
      }
      if (symptom1.includes("arch")) {
        this.setState({ selLeftArch: true });
      }
      if (symptom1.includes("heel")) {
        this.setState({ selLeftHeel: true });
      }
    } else {
      if (symptom1.includes("toe")) {
        this.setState({ seRightToe: true });
      }
      if (symptom1.includes("mts")) {
        this.setState({ selRightMts: true });
      }
      if (symptom1.includes("arch")) {
        this.setState({ selRightArch: true });
      }
      if (symptom1.includes("heel")) {
        this.setState({ selRightHeel: true });
      }
    }
  }

  submit() {
    let editInput = {
      id: this.props.userInfo.id,
      dispensed: this.props.userInfo.dispensed === "Yes" ? "Yes" : "No",
      authSecondaryContact: this.state.authSecondary ? "Yes" : "No",
      enableApp: this.state.enableApp,
      enableEmail: this.state.enableEmail,
      enableSms: this.state.enableSms
    };
    // let birthday = moment(
    //   this.state.birYear + "-" + this.state.birMonth + "-" + this.state.birDay
    // ).format("YYYY-MM-DD");
    let userInfo = _.clone(this.props.userInfo);
    if (this.props.patientSiteId && this.props.patientSiteId !== "") {
      Object.assign(editInput, { siteId: this.props.patientSiteId });
    }
    if (this.state.firstName && this.state.firstName !== "") {
      Object.assign(editInput, { firstName: this.state.firstName.trim() });
    }
    if (this.state.lastName && this.state.lastName !== "") {
      Object.assign(editInput, { lastName: this.state.lastName.trim() });
    }
    if (this.state.email) {
      Object.assign(editInput, { email: this.state.email.toLowerCase() });
    }
    if (this.state.patientMBI && this.state.patientMBI !== "") {
      Object.assign(editInput, { patientMBI: this.state.patientMBI });
    }
    if (this.state.patientResidence && this.state.patientResidence !== "") {
      Object.assign(editInput, {
        patientResidence: this.state.patientResidence
      });
    }
    if (!_.isEmpty(this.state.birthday)) {
      Object.assign(editInput, { birthday: this.state.birthday });
    }
    if (this.state.contactName) {
      Object.assign(editInput, {
        contactName: this.state.contactName
      });
    }
    if (this.state.secondaryEmail) {
      Object.assign(editInput, {
        secondaryEmail: this.state.secondaryEmail.toLowerCase()
      });
    }
    if (
      this.state.contactPhone &&
      !_.isEmpty(phoneWithCountryFormat(this.state.contactPhone))
    ) {
      Object.assign(editInput, {
        contactPhone: this.state.contactPhone
      });
    }
    if (this.state.relation && this.state.relation !== "") {
      Object.assign(editInput, {
        relation: this.state.relation
      });
    }
    if (this.state.patientNote && this.state.patientNote !== "") {
      Object.assign(editInput, {
        patientNotes: this.state.patientNote
      });
    }
    if (this.state.medicalCondition && this.state.medicalCondition !== "") {
      Object.assign(editInput, {
        medicalCondition: _.isEmpty(this.state.otherCondition)
          ? this.state.medicalCondition
          : this.state.medicalCondition + ",Other-" + this.state.otherCondition
      });
    }
    let hasPhone = false;
    if (
      this.state.homePhone &&
      !_.isEmpty(phoneWithCountryFormat(this.state.homePhone))
    ) {
      hasPhone = true;
      Object.assign(editInput, {
        homePhone: this.state.homePhone
      });
    }
    if (!_.isEmpty(phoneWithCountryFormat(this.state.phone))) {
      hasPhone = true;
      Object.assign(editInput, {
        phone: this.state.phone
      });
    }
    if (!hasPhone) {
      AntdModal.warning({
        title: "Incomplete Field",
        content: "Please enter a valid phone number.",
        centered: true
      });
      return;
    }
    if (this.props.dispenseType && this.props.dispenseType !== "") {
      Object.assign(editInput, {
        dispenseType: this.props.dispenseType
      });
    }
    if (this.state.dispenseSize && this.state.dispenseSize !== "") {
      Object.assign(editInput, {
        dispenseSize: this.state.dispenseSize
      });
    }
    if (this.state.dispenseColor && this.state.dispenseColor !== "") {
      Object.assign(editInput, {
        dispenseColor: this.state.dispenseColor
      });
    }
    if (this.state.dispenseAddress && this.state.dispenseAddress !== "") {
      Object.assign(editInput, {
        dispenseAddress: this.state.dispenseAddress
      });
    }
    if (this.state.dispenseCity && this.state.dispenseCity !== "") {
      Object.assign(editInput, {
        dispenseCity: this.state.dispenseCity
      });
    }
    if (this.state.dispenseState && this.state.dispenseState !== "") {
      Object.assign(editInput, {
        dispenseState: this.state.dispenseState
      });
    }
    if (this.state.dispenseZip && this.state.dispenseZip !== "") {
      Object.assign(editInput, {
        dispenseZip: this.state.dispenseZip
      });
    }
    if (this.state.dispenseComment && this.state.dispenseComment !== "") {
      Object.assign(editInput, {
        dispenseComments: this.state.dispenseComment
      });
    }
    if (this.props.doctorId && this.props.doctorId !== "") {
      Object.assign(editInput, {
        doctorId: this.props.doctorId
      });
    }
    if (this.state.gender && this.state.gender !== "") {
      Object.assign(editInput, {
        gender: this.state.gender
      });
    }
    if (this.state.patientId && this.state.patientId !== "") {
      Object.assign(editInput, {
        patientId: this.state.patientId
      });
    }

    if (
      this.props.patientHasSmartPhone &&
      this.props.patientHasSmartPhone !== ""
    ) {
      Object.assign(editInput, {
        patientHasSmartPhone: this.props.patientHasSmartPhone
      });
    }

    if (this.props.patientHasWifi && this.props.patientHasWifi !== "") {
      Object.assign(editInput, { patientHasWifi: this.props.patientHasWifi });
    }

    let symptomDetail = "";
    let rightSymptom = "",
      leftSymptom = "";
    if (this.state.selRightToe) {
      if (_.isEmpty(rightSymptom)) {
        rightSymptom = "toe";
      } else {
        rightSymptom = rightSymptom + "_toe";
      }
    }
    if (this.state.selRightMts) {
      if (_.isEmpty(rightSymptom)) {
        rightSymptom = "mts";
      } else {
        rightSymptom = rightSymptom + "_mts";
      }
    }
    if (this.state.selRightArch) {
      if (_.isEmpty(rightSymptom)) {
        rightSymptom = "arch";
      } else {
        rightSymptom = rightSymptom + "_arch";
      }
    }
    if (this.state.selRightHeel) {
      if (_.isEmpty(rightSymptom)) {
        rightSymptom = "heel";
      } else {
        rightSymptom = rightSymptom + "_heel";
      }
    }
    if (this.state.selLeftToe) {
      if (_.isEmpty(leftSymptom)) {
        leftSymptom = "toe";
      } else {
        leftSymptom = leftSymptom + "_toe";
      }
    }
    if (this.state.selLeftMts) {
      if (_.isEmpty(leftSymptom)) {
        leftSymptom = "mts";
      } else {
        leftSymptom = leftSymptom + "_mts";
      }
    }
    if (this.state.selLeftArch) {
      if (_.isEmpty(leftSymptom)) {
        leftSymptom = "arch";
      } else {
        leftSymptom = leftSymptom + "_arch";
      }
    }
    if (this.state.selLeftHeel) {
      if (_.isEmpty(leftSymptom)) {
        leftSymptom = "heel";
      } else {
        leftSymptom = leftSymptom + "_heel";
      }
    }
    if (_.isEmpty(leftSymptom)) {
      if (!_.isEmpty(rightSymptom)) {
        symptomDetail = `right:${rightSymptom}`;
      }
    } else {
      if (_.isEmpty(rightSymptom)) {
        symptomDetail = `left:${leftSymptom}`;
      } else {
        symptomDetail = `left:${leftSymptom},right:${rightSymptom}`;
      }
    }
    if (!_.isEmpty(symptomDetail)) {
      Object.assign(editInput, {
        symptomDetail
      });
    }

    const { changeNewPatient } = this.props;
    changeNewPatient(editInput, userInfo, this);
  }
  close = () => {
    this.setState({
      open: false,
      firstName: "",
      lastName: "",
      confirmSuccess: false,
      enableWarning: false
    });
  };

  changePatientNote = event => {
    this.setState({ patientNote: event.target.value });
  };

  onChangeAuthSecondary = event => {
    this.setState({ authSecondary: event.target.checked });
  };

  handleMonthChange = event => {
    this.setState({ birMonth: event.target.value });
  };

  handleDayChange = event => {
    this.setState({ birDay: event.target.value });
  };

  handleYearChange = event => {
    this.setState({ birYear: event.target.value });
  };

  handlePatientIdChange = event => {
    this.setState({ patientId: event });
  };

  handleHomePhoneChange = phone => {
    let noSym1 = phone.replace("(", "");
    let noSym2 = noSym1.replace(")", "");
    let noSym3 = noSym2.replace("-", "");
    let noBlank = noSym3.replace(/\s+/g, "");
    this.setState({ homePhone: noBlank });
  };

  handleCellPhoneChange = phone => {
    let noSym1 = phone.replace("(", "");
    let noSym2 = noSym1.replace(")", "");
    let noSym3 = noSym2.replace("-", "");
    let noBlank = noSym3.replace(/\s+/g, "");
    this.setState({ phone: noBlank });
  };

  warning = () => {
    this.setState({ enableWarning: true });
    AntdModal.warning({
      title: "Update Shipping Address",
      content: "Updated shipping address will apply to future orders.",
      centered: true
    });
  };

  render() {
    const { Option } = Select;
    const { open } = this.state;
    return (
      <Modal
        trigger={
          <Button
            onClick={this.handleOpen}
            size="mini"
            style={{ display: "none" }}
          >
            Edit
          </Button>
        }
        open={open}
        style={{ width: "1080px" }}
      >
        <Modal.Header>Edit Patient</Modal.Header>
        <Modal.Content>
          {this.state.confirmSuccess ? (
            <ButtonSuccess />
          ) : (
            <Tabs style={{ height: 600, overflowY: "auto" }}>
              <TabPane tab="Enroll" key="1">
                <div className="newSite_box">
                  <div className="Patient_group">
                    <EnrollmentCriteria userInfo={this.props.userInfo || {}} />
                  </div>
                </div>
              </TabPane>
              <TabPane tab="Profile" key="2">
                <div className="newSite_box">
                  <div className="Patient_group">
                    <p
                      className="step3_section_title"
                      style={{ width: "790px" }}
                    >
                      Patient Information
                    </p>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputLeftTotal">
                        <p className="inputLable">First Name</p>
                        <Input
                          placeholder="John"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.handleFirstNameChange(e.target.value);
                          }}
                          value={this.state.firstName}
                        />
                      </div>
                      <div className="inputLeftTotal">
                        <p className="inputLable">Last Name</p>
                        <Input
                          placeholder="Smith"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.handleLastNameChange(e.target.value);
                          }}
                          value={this.state.lastName}
                        />
                      </div>
                      <div className="inputrightTotal">
                        <p className="inputLable">Date of Birth(DOB)</p>
                        <DatePicker
                          className="inputContent"
                          onChange={date => {
                            this.setState({
                              birthday: moment(date).format("YYYY-MM-DD")
                            });
                          }}
                          defaultValue={moment(this.state.birthday)}
                        />
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputLeftTotal">
                        <p className="inputLable">Username</p>
                        {this.props.userInfo.id &&
                        this.props.userInfo.id.includes("@") ? (
                          <Input
                            value={this.props.userInfo.id}
                            className="inputContent"
                            disabled
                          />
                        ) : (
                          <ReactPhoneInput
                            inputExtraProps={{
                              name: "phone",
                              required: true,
                              autoFocus: false
                            }}
                            value={this.props.userInfo.id}
                            defaultCountry={"us"}
                            disableAreaCodes
                            disabled
                          />
                        )}
                      </div>
                      <div className="inputLeftTotal">
                        <p className="inputLable">Cell Phone</p>
                        <ReactPhoneInput
                          inputExtraProps={{
                            name: "phone",
                            required: true,
                            autoFocus: false
                          }}
                          value={this.state.phone}
                          defaultCountry={"us"}
                          onChange={cellPhone =>
                            this.handleCellPhoneChange(cellPhone)
                          }
                          disableAreaCodes
                        />
                      </div>
                      <div className="inputrightTotal">
                        <p className="inputLable">Home Phone</p>
                        <ReactPhoneInput
                          inputExtraProps={{
                            name: "phone",
                            required: true,
                            autoFocus: false
                          }}
                          value={this.state.homePhone}
                          defaultCountry={"us"}
                          onChange={homePhone =>
                            this.handleHomePhoneChange(homePhone)
                          }
                          disableAreaCodes
                        />
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputLeftTotal">
                        <p className="inputLable">Email</p>
                        <Input
                          placeholder="Johnsmith@email.com"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.handleEmailChange(e.target.value);
                          }}
                          value={this.state.email}
                        />
                      </div>
                      <div className="inputLeftTotal">
                        <p className="inputLable">Gender</p>
                        <Select
                          className="selectStyle"
                          onChange={this.changeGender}
                          value={this.state.gender}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          optionFilterProp="children"
                        >
                          {GenderList.map((si, i) => {
                            return (
                              <Option value={si.gender} key={"si" + i}>
                                {si.gender}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                      <div className="inputrightTotal">
                        <p className="inputLable">Patient ID</p>
                        <Input
                          placeholder="123456"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.handlePatientIdChange(e.target.value);
                          }}
                          value={this.state.patientId}
                        />
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputLeftTotal">
                        <p className="inputLable">MBI</p>
                        <Input
                          placeholder="Medicare Beneficiary Identifier"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.changeMBI(e.target.value);
                          }}
                          value={this.state.patientMBI}
                        />
                      </div>
                      <div className="inputLeftTotal">
                        <p className="inputLable">Patient Residence</p>
                        <Select
                          className="selectStyle"
                          onChange={this.changePatientResidence}
                          value={this.state.patientResidence}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          optionFilterProp="children"
                        >
                          {PATIENT_RESIDENCE.map((si, i) => {
                            return (
                              <Option value={si.value} key={"si" + i}>
                                {si.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputTotal PaInforBox">
                        <p className="inputLable">
                          Shipping Address
                          <span style={{ color: "red" }}> *</span>
                        </p>
                        <p className="redAddressTip">
                          Required for shipping and/or replacements. No P.O. Box
                          deliveries
                        </p>
                        <Input
                          style={{ width: "45%", height: 45 }}
                          placeholder="Address"
                          value={this.state.dispenseAddress}
                          onChange={e => {
                            const value = e.target.value;
                            if (
                              !_.isEqual(value, this.state.dispenseAddress) &&
                              !this.state.enableWarning
                            ) {
                              this.warning();
                            }
                            this.setState({ dispenseAddress: value });
                          }}
                        />
                        <Input
                          style={{ width: "27%", height: 45, marginLeft: "1%" }}
                          placeholder="City"
                          value={this.state.dispenseCity}
                          onChange={e => {
                            const value = e.target.value;
                            if (
                              !_.isEqual(value, this.state.dispenseCity) &&
                              !this.state.enableWarning
                            ) {
                              this.warning();
                            }
                            this.setState({ dispenseCity: value });
                          }}
                        />
                        <Input
                          style={{ width: "12%", marginLeft: "1%", height: 45 }}
                          placeholder="State"
                          value={this.state.dispenseState}
                          onChange={e => {
                            const value = e.target.value;
                            if (
                              !_.isEqual(value, this.state.dispenseState) &&
                              !this.state.enableWarning
                            ) {
                              this.warning();
                            }
                            this.setState({ dispenseState: value });
                          }}
                        />
                        <Input
                          style={{ width: "12%", marginLeft: "1%", height: 45 }}
                          placeholder="Zip"
                          value={this.state.dispenseZip}
                          onChange={e => {
                            const value = e.target.value;
                            if (
                              !_.isEqual(value, this.state.dispenseZip) &&
                              !this.state.enableWarning
                            ) {
                              this.warning();
                            }
                            this.setState({ dispenseZip: value });
                          }}
                        />
                      </div>
                      <div
                        className="inputTotal PaInforBox"
                        style={{ marginTop: 20 }}
                      >
                        <p className="inputLable">
                          Preferred Contact Method (Select all that apply)
                        </p>
                        <Checkbox
                          onChange={this.onChangeContactPhone}
                          checked={this.state.enableApp}
                          style={{ marginRight: 10, marginTop: 10 }}
                        >
                          App Notification
                        </Checkbox>
                        <Checkbox
                          onChange={this.onChangeContactEmail}
                          checked={this.state.enableEmail}
                          style={{ marginRight: 10, marginTop: 10 }}
                        >
                          Email
                        </Checkbox>
                        <Checkbox
                          onChange={this.onChangeContactMessage}
                          checked={this.state.enableSms}
                          style={{ marginRight: 10, marginTop: 10 }}
                        >
                          SMS/Text Message
                        </Checkbox>
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <div className="clear_both" />
                    </div>
                  </div>
                  <div className="Secondary_group_edit">
                    <p
                      className="step3_section_title"
                      style={{ width: "790px" }}
                    >
                      Secondary Contact Information
                    </p>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputLeftTotal">
                        <p className="inputLable">Secondary Contact Name</p>
                        <Input
                          placeholder="John"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.handleContactNameChange(e.target.value);
                          }}
                          value={this.state.contactName}
                        />
                      </div>
                      <div className="inputLeftTotal">
                        <p className="inputLable">Secondary Contact Email</p>
                        <Input
                          placeholder="Johnsmith@email.com"
                          className="inputContent"
                          onChange={(e, data) => {
                            this.handleSecondaryEmailChange(e.target.value);
                          }}
                          value={this.state.secondaryEmail}
                        />
                      </div>
                      <div className="inputrightTotal">
                        <p className="inputLable">Secondary Contact Phone</p>
                        <ReactPhoneInput
                          inputExtraProps={{
                            name: "phone",
                            required: true,
                            autoFocus: false
                          }}
                          value={this.state.contactPhone}
                          defaultCountry={"us"}
                          onChange={contactPhone =>
                            this.handlePhoneChange(contactPhone)
                          }
                          disableAreaCodes
                        />
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <div className="inputLeftTotal">
                        <p className="inputLable">Relationship To Patient</p>
                        <Select
                          className="selectStyle"
                          value={this.state.relation}
                          onChange={this.handleRelChange}
                          style={{ width: "100%" }}
                          placeholder="Please Select"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          optionFilterProp="children"
                        >
                          {SecRela.map((relation, i) => {
                            return (
                              <Option
                                value={relation.rela}
                                key={"relation" + i}
                              >
                                {relation.rela}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                      <div className="clear_both" />
                    </div>
                    <div className="inputTotal step3InputTotal">
                      <AntdCheckbox
                        onChange={this.onChangeAuthSecondary}
                        checked={this.state.authSecondary}
                        style={{ marginTop: 10, marginBottom: 20 }}
                      >
                        HIPAA Authorization obtained for Secondary Contact
                      </AntdCheckbox>
                    </div>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          )}
        </Modal.Content>
        <Modal.Actions style={{ textAlign: "center" }}>
          <Button
            color="green"
            onClick={e => this.submit()}
            // onClick={e => this.close()}
            style={{
              display: this.state.confirmSuccess ? "none" : "inline-block"
            }}
          >
            <Icon name="checkmark" />
            Submit
          </Button>
          <Button basic color="red" onClick={e => this.close()}>
            <Icon name="remove" />
            {this.state.confirmSuccess ? "Close" : "Cancel"}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
const mapStateToProp = state => ({
  prescribingStaff: state.patientsListStore.prescribingStaff,
  filterGroup: state.patientsListStore.filterGroup,
  clinicSites: state.patientsListStore.clinicSites,
  patientSiteId: state.patientsListStore.patientSiteId,
  doctorId: state.patientsListStore.doctorId,
  dispenseType: state.patientsListStore.dispenseStyle,
  patientHasSmartPhone: state.patientsListStore.ifHavePhone,
  patientHasWifi: state.patientsListStore.ifHaveWifi
});
const mapDispatchToProp = dispatch => ({
  changeNewPatient: (editInput, userInfo, self) =>
    dispatch(changeNewPatient(editInput, userInfo, self)),
  getGroups: () => dispatch(getGroups()),
  getPrescribingStaff: staffSiteId =>
    dispatch(getPrescribingStaff(staffSiteId)),
  getPrescribingStaffChanged: (staffSiteId, self) =>
    dispatch(getPrescribingStaffChanged(staffSiteId, self))
});
export default connect(mapStateToProp, mapDispatchToProp)(EditNewPatientsList);
